import commitmentModelDefinition from './'

export function instantiate_commitment_from_template( user_id, parent_goal_id, template, BACKEND ) {

  let commitment = commitmentModelDefinition.schema.create({
    user_id: user_id,
    type:    template.type,
    goal_id: parent_goal_id
  }, {}, BACKEND);

  if ( template.type === 'NONE' ) {
    throw new Error('This template must be instantiated with instantiate_goal_from_template.')
  }

  commitment.templateId = template.id;
  commitment.type = template.type;
  commitment.name = template.name;
  commitment.allowToEdit = template.allowToEdit;

  switch ( template.type ) {
    case 'COMMITMENT_TEMPLATE':
      commitment.commitmentTemplateId = template.commitmentTemplateId;
      commitment.dataFields           = template.dataFields;
      commitment.sessionLength        = Number.parseInt(template.sessionLength);
      commitment.maxSessionsPerDay    = template.maxSessionsPerDay;
      commitment.maxSessionsPerWeek   = template.maxSessionsPerWeek;
    break

    case 'COMMITMENT':
      commitment.commitmentOptionsSelected = template.commitmentOptionsSelected;
      // commitment.minSessionsPerDay   = template.minSessionsPerDay;
      commitment.maxSessionsPerDay   = template.maxSessionsPerDay;
      commitment.sessionLength       = Number.parseInt(template.sessionLength);
      commitment.customAmount        = template.customAmount || 0;
      commitment.customFrequency     = template.customFrequency || 'perWeek';
      commitment.finishedPercent     = template.finishedPercent || 0;
      commitment.amountAchieved      = 0;
      commitment.noSessionsAfterDeadline = template.noSessionsAfterDeadline;
    break

    case 'SEQUENCE_TYPE1':
      commitment.sessionTemplateListType1 = template.sessionTemplateListType1;
    break

    case 'SEQUENCE_TYPE2':
      commitment.sessionTemplateListType2 = template.sessionTemplateListType2 || [];
      commitment.lastCompletedSeqItemId   = template.lastCompletedSeqItemId || null;
      commitment.templateRepeat           = template.templateRepeat;
      commitment.completedSequences       = 0;
      commitment.allowSessionToBeSkipped  = template.allowSessionToBeSkippe || false;
    break

    case 'FIXED_TSC':
      /* In case of FIXED_TSC we have to create a TSC */
      // let commitmentTscId = createTscCallback( template.timeslotCollectionTemplate );
      // commitment.commitmentTscId = commitmentTscId;
      // TODO: starDate endDate kopieren in rules
      commitment.commitmentTscId = 'TODO';
    break

    case 'SPRINT':
    throw new Error('NOT IMPLEMENTED')
  }

  if ( template.createGoalOnInstatiation ) {
    /* we also have to instantiate a new goal */
    // let parentGoalId = createGoalCallback( template.goalTemplate );
    // commitment.parentGoalId = parentGoalId;
    /* ^ this probably won't work */
    // --> We will handles this later
  }

  /* add graphical representation */
  commitment.graphicalRepresentation = {
    fontFamily:   "Roboto",
    fontSize:     15,
    fill:         '#ffffff',
    show:         true,
  };

  /* copy start or end date if defined (not null) */
  if ( template.startDate ) {
    commitment.startDate = template.startDate;
  }
  if ( template.endDate ) {
    commitment.endDate = template.endDate;
  }

  /* After or before instantiation user has to assign:

  - timeslotCollectionId
  - parentGoalId

  and usually:

  - startDate
  - endDate
  */

  return commitment;
}
